export default __webpack_public_path__ + "static/media/ff_ja.028fa9b3.png";